// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-entry {
    border: 1px solid rgba(128,128,128,0.35);
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 8px;
}
.index-field {
    padding: 2px 6px;
    margin-right: 4px;
    border: 1px solid rgba(128,128,128,0.35);
    border-radius: 12px;
}
.index-hint {
    font-size: 11px;
    opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/dataobject/dataobject.index.dialog.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".index-entry {\n    border: 1px solid rgba(128,128,128,0.35);\n    border-radius: 4px;\n    padding: 8px;\n    margin-bottom: 8px;\n}\n.index-field {\n    padding: 2px 6px;\n    margin-right: 4px;\n    border: 1px solid rgba(128,128,128,0.35);\n    border-radius: 12px;\n}\n.index-hint {\n    font-size: 11px;\n    opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
